
import { ref, inject } from "vue";
import { Dialog } from "vant";
import { useRouter, useRoute } from "vue-router";
export default {
  props: {
    item: {
      //当前对象
      type: Object,
      default: () => {
        return {};
      },
    },
    delete_fn: {
      //删除按钮
      type: Function,
    },
    address_message: {
      type: Boolean,
      default: true,
    },

  },
  setup(props: any, { emit }: any) {
    let route = useRoute()
    let router = useRouter()
    const checked = ref("1");
    const $store: any = inject("$store");
    let is_checkout = ref(route.query.is_checkout)
    let isShowCheck = ref(route.query.isShowCheck)  // 是否显示可选框 0/无/'afterSale'则不显示(传'afterSale'可表示从售后来，如果还想返回售后页面),反之大于0则显示,目前是售后专用的,之所以重新开一个变量,是因为选择地址后还需要返回到售后的页面中去,而is_checkout并不能满足这个特殊的需要
    let isFiltrate = ref(route.query.isFiltrate) // 是否筛选上门取件 1表示需要筛选,0表示不用
    const removeAddr = (item: Object) => {
      Dialog.confirm({
        message: "Are you sure to remove it?",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
        .then(() => {
          emit("delete_fn", item);
        })
        .catch(() => {
          // on cancel
        });
    };
    const compileEdit = (item: Object) => {
      emit("edit_fn", item);
    };
    const place_rder_fnc = (item: any) => {
      if (route.query.is_checkout) {
         router.push({
            path: "/checkout",
            query: {
              address_id: item.address_id
            }
          });
      }
      if(isShowCheck.value) {
        // 需要筛选上门取件地址时,如果当前所选地址 area_pickup 为0 则不支持上门取件 1则支持上门取件 ,另dlyp_id>0表示是自提点页则不能作为上门地址
        // 不支持上门取件时不可选中
        if((!item.area_pickup||item.dlyp_id>0)&&isFiltrate.value === '1'){
          return
        }
          router.push({
            name: $store.getGoBack().replace('/',''),
            params: {
              addressMsg: JSON.stringify(item),
            }
          });
        }
    }

    return {
      checked,
      removeAddr,
      compileEdit,
      is_checkout,
      isShowCheck,
      isFiltrate,
      place_rder_fnc
    };
  },
};
